import useApiRequest from "@/lib/hooks/use-request";
import { CalculationNumberResponseDto } from "@/lib/interfaces/numbers";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import NumbersDetails from "./details";

const NumbersFetcher = ({
  isEditing,
  setIsEditing,
}: {
  isEditing: boolean;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
}) => {
  const { apiRequest } = useApiRequest();
  const [item, setItem] = useState<CalculationNumberResponseDto>();
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);

  const getItem = useCallback(async () => {
    setIsLoading(true);
    const response = await apiRequest<CalculationNumberResponseDto>("settings/calculation-numbers", "GET");
    if (response.data) {
      setItem(response.data);
      setIsEditing(false);
    }
    setIsLoading(false);
  }, [apiRequest, setIsEditing]);

  useEffect(() => {
    getItem();
  }, [reload, getItem]);

  return (
    <DataFetchParent
      data={item}
      isLoading={isLoading}
      renderElement={(response: CalculationNumberResponseDto) => (
        <div className="w-full p-4">
          <NumbersDetails item={response} setReload={setReload} isEditing={isEditing} />
        </div>
      )}
    />
  );
};

export default NumbersFetcher;
